import { useSyncExternalStore } from "react";

export const DESKTOP_QUERY = "(min-width: 1024px)";

function subscribe(query: string, onChange: () => void) {
  if (typeof window.matchMedia !== "function") return () => undefined;
  const list = window.matchMedia(query);
  list.addEventListener("change", onChange);
  return () => {
    list.removeEventListener("change", onChange);
  };
}

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => subscribe(query, onChange),
    () => typeof window.matchMedia === "function" && window.matchMedia(query).matches,
    () => false,
  );
}
